/* v3.4: Browse-only inquiries and navigation that survive theme-editor section reloads. */
(function () {
  'use strict';

  var initializedForms = new WeakSet();

  function forEachMatch(root, selector, callback) {
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function updateInquiry(infoButton) {
    var productInfo = infoButton.closest('.product-information');
    if (!productInfo) return;
    var optionsBox = productInfo.querySelector('[data-usa-product-options]');
    var heading = productInfo.querySelector('h1');
    var title = optionsBox ? optionsBox.getAttribute('data-product-title') : (heading ? heading.textContent.trim() : '');
    var url = optionsBox ? optionsBox.getAttribute('data-product-url') : window.location.origin + window.location.pathname;
    var selections = [];
    if (optionsBox) {
      optionsBox.querySelectorAll('.catalog-option-select').forEach(function (select) {
        selections.push((select.getAttribute('data-option-label') || 'Option') + ': ' + select.value);
      });
      var summary = optionsBox.querySelector('.catalog-selection-summary');
      var summaryText = selections.length ? 'Selected: ' + selections.join(' · ') : '';
      if (summary && summary.textContent !== summaryText) summary.textContent = summaryText;
    }
    var params = new URLSearchParams();
    if (title) params.set('product', title);
    if (selections.length) params.set('options', selections.join(', '));
    if (url) params.set('product_url', url);
    infoButton.href = '/pages/free-assessment-form-for-stairlifts-handicap-ramps?' + params.toString();
  }

  function initializeRequestForm(panel) {
    // A section can be loaded more than once; keep any edits the visitor has made.
    if (initializedForms.has(panel)) return;
    initializedForms.add(panel);
    var query = new URLSearchParams(window.location.search);
    var product = (query.get('product') || '').slice(0, 180);
    var category = (query.get('category') || '').slice(0, 180);
    var options = (query.get('options') || '').slice(0, 500);
    var source = (query.get('product_url') || '').slice(0, 500);
    var text = (category + ' ' + product).toLowerCase();
    var keywordCategories = [
      [/scrub|uniform|embroidery/, 'Scrubs & Medical Uniforms'],
      [/compression|stocking/, 'Compression Stockings'],
      [/stairlift|chair lift for stairs/, 'Stairlifts — Sales & Rentals'],
      [/ramp|ez.access/, 'Wheelchair Ramps — Sales & Rentals'],
      [/transport chair|manual wheelchair/, 'Wheelchairs & Transport Chairs'],
      [/power chair|power wheelchair|scooter/, 'Power Wheelchairs & Scooters'],
      [/lift chair|recliner/, 'Lift Chairs'],
      [/rollator|walker/, 'Walkers & Rollators'],
      [/hospital bed|bed rail/, 'Hospital Beds'],
      [/grab bar|bathroom|shower chair|commode/, 'Bathroom Safety & Grab Bars'],
      [/cpap|sleep therapy|resmed/, 'CPAP Machines & Supplies']
    ];
    var interests = panel.querySelectorAll('[data-usa-interest]');
    keywordCategories.forEach(function (pair) {
      if (pair[0].test(text)) {
        interests.forEach(function (field) {
          if (field.getAttribute('data-usa-interest') === pair[1]) field.checked = true;
        });
      }
    });
    if (/free-assessment-form-for-stairlifts-handicap-ramps/.test(window.location.pathname.toLowerCase()) && !product) {
      var assessment = panel.querySelector('input[name="contact[Inquiry type]"][value="Free home accessibility assessment"]');
      if (assessment) assessment.checked = true;
    }
    var note = panel.querySelector('#usa-request-body');
    if (note && !note.value.trim() && (product || options || source)) {
      var lines = [];
      if (product) lines.push('Product: ' + product);
      if (options) lines.push('Selected options: ' + options);
      if (source && /^https?:\/\//i.test(source)) lines.push('Product page: ' + source);
      note.value = lines.join('\n') + '\n\nMy question: ';
    }
  }

  function normalizeAssessmentLink(link) {
    var raw = link.getAttribute('href');
    if (!raw) return;
    var target;
    try { target = new URL(raw, window.location.href); } catch (error) { return; }
    if (target.origin !== window.location.origin) return;
    if (target.pathname.replace(/\/$/, '') !== '/pages/free-assessment-form-for-stairlifts-handicap-ramps') return;
    if (link.matches('.catalog-inquiry-button, .header-contact') || link.closest('.browse-only-cart')) return;
    if (target.searchParams.has('product')) return;
    var label = link.textContent + ' ' + (link.getAttribute('aria-label') || '');
    if (/information|inquir|contact/i.test(label) && !/assess/i.test(label)) return;
    var hash = target.hash === '#contact_form' ? '#USAHomeAssessment' : target.hash;
    link.setAttribute('href', '/pages/free-assessment-form-2027' + target.search + hash);
  }

  function initialize(root) {
    forEachMatch(root, 'a[href]', normalizeAssessmentLink);
    forEachMatch(root, '.catalog-inquiry-button', updateInquiry);
    forEachMatch(root, '[data-usa-request-form]', initializeRequestForm);
    forEachMatch(root, '#usa-page-contact-message, #contact-message', function (message) {
      if (message.value.trim()) return;
      var params = new URLSearchParams(window.location.search);
      var product = params.get('product');
      if (!product) return;
      var lines = ['I would like information about: ' + product];
      if (params.get('options')) lines.push('Preferred options: ' + params.get('options'));
      if (params.get('product_url')) lines.push('Product page: ' + params.get('product_url'));
      lines.push('', 'My question: ');
      message.value = lines.join('\n');
    });
  }

  // Delegated listeners also work on a header or product section replaced by Shopify.
  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('.catalog-option-select')) return;
    var productInfo = event.target.closest('.product-information');
    var infoButton = productInfo && productInfo.querySelector('.catalog-inquiry-button');
    if (infoButton) updateInquiry(infoButton);
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('.usa-menu-toggle');
    if (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel) {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        panel.classList.toggle('is-open', !open);
        if (open) panel.querySelectorAll('.usa-departments[open], .usa-primary-menu[open]').forEach(function (item) { item.open = false; });
      }
    }
    document.querySelectorAll('.usa-departments[open], .usa-primary-menu[open]').forEach(function (item) {
      if (!item.contains(event.target)) item.open = false;
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var active = document.activeElement;
    var activeMenu = active && active.closest('.usa-departments[open], .usa-primary-menu[open]');
    var focusTarget = activeMenu ? activeMenu.querySelector('summary') : null;
    document.querySelectorAll('.usa-departments[open], .usa-primary-menu[open]').forEach(function (item) { item.open = false; });
    document.querySelectorAll('.usa-menu-toggle[aria-expanded="true"]').forEach(function (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel && panel.classList.contains('is-open')) {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        focusTarget = toggle;
      }
    });
    // Keep keyboard focus on a visible control after closing a submenu.
    if (focusTarget) focusTarget.focus();
  });

  // Native details "toggle" events do not bubble; capture handles newly rendered menus.
  document.addEventListener('toggle', function (event) {
    var item = event.target;
    if (!item.matches || !item.matches('.usa-primary-menu') || !item.open) return;
    var nav = item.closest('.usa-nav') || document;
    nav.querySelectorAll('.usa-primary-menu[open]').forEach(function (other) {
      if (other !== item) other.open = false;
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
}());
